// extracted by mini-css-extract-plugin
export default {"presentationDescription":"presentationDescription_presentationDescription__peIqI","presentationDescription__text":"presentationDescription_presentationDescription__text__qyYFw"};